/* eslint-disable import/prefer-default-export */
export const uiConstants = {
  SET_PAGE_TITLE: 'UI_SET_PAGE_TITLE',
};
